const DATE_REFUND_BOOKING_STATUSES = new Set([
  "Accepted",
  "Paid",
  "Completed",
  "Cancelled",
  "Cancel_Scheduled",
]);

export function canManageDateScopedRefund(status) {
  return DATE_REFUND_BOOKING_STATUSES.has(status);
}
